import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/functions'
import 'firebase/messaging'
import 'firebase/storage'

// Initialize Firebase
const config = {
	apiKey: "AIzaSyC4EFlJ61E_zM2wgjE-qdCNeFE553JdOHY",
	authDomain: "bigscoots-portal.firebaseapp.com",
	databaseURL: "https://bigscoots-portal.firebaseio.com",
	projectId: "bigscoots-portal",
	storageBucket: "bigscoots-portal.appspot.com",
	messagingSenderId: "698384552834",
	appId: "1:698384552834:web:61b678d66e6ef7de16b59b"
};
const firebaseApp = firebase.initializeApp(config);
firebaseApp.firestore().settings({})

export const db = firebaseApp.firestore()
export const auth = firebaseApp.auth()
export const storage = firebaseApp.storage()
let firebaseMessaging = null;

if(firebase.messaging.isSupported()){
	firebaseMessaging = firebaseApp.messaging();
	firebaseMessaging.usePublicVapidKey('BH2mco7yz6hb_Q2kgJeyBy3TaKkNRiX1sl1-7AgpIjH0tDW_TxXAp1Dd42aTOa3lzDwaePW5rnB8Lc2MkmszmBU');
}
// export const authSession = firebase.auth.Auth.Persistence.SESSION
export const functions = firebase.functions();
export const messaging = firebaseMessaging;
